<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import { Button } from "vant";

export default {
  name: "App",
  components: {
    [Button.name]: Button,
  },
  created: function() {},
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  margin-top: 3vh;
}
body {
  background: #e8e8f694;
}
</style>
